import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as ViveroServices from "../../../../services/ViveroService";
import { useTranslation } from "react-i18next";
import ViveroForm from "./viveroForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

const ViveroFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      name: data.name,
      code: data.code,
      active: data.active,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await ViveroServices.getVivero(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await ViveroServices.updateVivero(values, uuid);
        } else {
          result = await ViveroServices.addVivero(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.vivero.messages.update.title");
            text = t("forms.vivero.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.vivero.messages.create.title");
            text = t("forms.vivero.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.vivero.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.VIVERO_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.VIVERO_LIST);
  };

  return (
    <ViveroForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
    />
  );
};

ViveroFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ViveroFormContainer;
